var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4493 14.8004L11.582 10.7782C12.5767 9.59802 13.1219 8.10404 13.1212 6.56059C13.1212 2.94314 10.178 0 6.56059 0C2.94314 0 0 2.94314 0 6.56059C0 10.178 2.94314 13.1212 6.56059 13.1212C7.91863 13.1212 9.21278 12.7116 10.3192 11.934L14.2159 15.9867C14.3788 16.1559 14.5979 16.2492 14.8326 16.2492C15.0548 16.2492 15.2656 16.1644 15.4257 16.0104C15.589 15.8529 15.6832 15.6371 15.6876 15.4103C15.6921 15.1835 15.6064 14.9641 15.4493 14.8004ZM6.56059 1.71146C9.23446 1.71146 11.4097 3.88672 11.4097 6.56059C11.4097 9.23446 9.23446 11.4097 6.56059 11.4097C3.88672 11.4097 1.71146 9.23446 1.71146 6.56059C1.71146 3.88672 3.88672 1.71146 6.56059 1.71146Z",
    fill: "#224846"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.017ea70e1c603b8d478777a38158b0ba.svg";
export { ForwardRef as ReactComponent };